import { useEffect, useState } from 'react'

/**
 * Reports whether the user is idle. Idle means the tab is hidden (switched away or
 * minimized), detected via the native `visibilitychange` event — no activity timers,
 * no polling.
 */
export const useIdle = (): boolean => {
  const [idle, setIdle] = useState(() => document.hidden)

  useEffect(() => {
    const onChange = () => setIdle(document.hidden)
    document.addEventListener('visibilitychange', onChange)
    return () => document.removeEventListener('visibilitychange', onChange)
  }, [])

  return idle
}
